module.exports = __webpack_public_path__ + "img/592-42dfb3.png";